<template>
  <div id="app">
    <AppHeader/>
    <router-view/>
    <AppFooter/>
  </div>
</template>
<script>
import AppHeader from "@/components/AppHeader";
import AppFooter from "@/components/AppFooter";
export default {
  components: {
    AppHeader,
    AppFooter
  },
  mounted() {
    document.querySelector("body").classList.remove('load')
  }
}
</script>
<style lang="scss">
@import "public/static/style/style";
// Const
$cRed: #EF3527;
$cBlack: #252525;
$cYellow: #FFA630;
$cWhite: #FFFFFF;
$cGrey: rgba(55, 57, 46, .5);

#app {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  height: 100%;
}
</style>
